export default __webpack_public_path__ + "static/media/unknown.a9db18aa.svg";